import { __assign, __values } from "tslib";
import { AppType } from '@office-start/app-gallery-types';
import { aadAppPlatformType, copilotM365AppId, dynamicsAppPlatformType, editorAppId, lobAppPlatformType, m365AppPlatformType, onedriveMOSAppId, } from './constants';
import { getHubTileIdFromFirstPartyWorkloadId } from './getHubTileIdFromFirstPartyWorkloadId';
export function getPlatformType(collectorId) {
    switch (collectorId) {
        case AppType.FirstParty:
            return undefined;
        case AppType.Mos:
            return m365AppPlatformType;
        case AppType.Dynamics:
            return dynamicsAppPlatformType;
        case AppType.AAD:
            return aadAppPlatformType;
        case AppType.LOB:
            return lobAppPlatformType;
    }
    return undefined;
}
export function parseAppTypeByCollectorId(collectorId) {
    if (Object.values(AppType).includes(collectorId)) {
        return collectorId;
    }
    return AppType.Unknown;
}
export function isAppPinnable(appId, collectorId) {
    if (appId === copilotM365AppId ||
        appId === onedriveMOSAppId ||
        appId === editorAppId) {
        // The Editor app tile, the copilot or onedrive MetaOS apps are not pinnable
        return false;
    }
    switch (collectorId) {
        case AppType.FirstParty:
        case AppType.Mos:
        case AppType.Dynamics:
        case AppType.AAD:
        case AppType.LOB:
            return true;
        default:
            return false;
    }
}
export function isAppPinned(userData, id) {
    var e_1, _a;
    // Use known hub tile ids if available, ex: ShellTeams instead of Teams
    id = getHubTileIdFromFirstPartyWorkloadId(id) || id;
    try {
        for (var _b = __values(userData.pinnedApps), _c = _b.next(); !_c.done; _c = _b.next()) {
            var app = _c.value;
            if (app.id === id) {
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
}
export function pinApp(userData, id, platformType, pinSource) {
    // Use known hub tile ids if available, ex: ShellTeams instead of Teams
    id = getHubTileIdFromFirstPartyWorkloadId(id) || id;
    if (isAppPinned(userData, id)) {
        // App is already pinned
        return userData;
    }
    var pinnedApps = userData.pinnedApps
        .concat({
        id: id,
        platformType: platformType,
        pinnedIndex: Number.MAX_VALUE,
        pinSource: pinSource,
    })
        .sort(function (item1, item2) { return item1.pinnedIndex - item2.pinnedIndex; })
        .map(function (app, index) { return (__assign(__assign({}, app), { pinnedIndex: index })); }); // Renumber the indexes beginning with 0
    return __assign(__assign({}, userData), { pinnedApps: pinnedApps });
}
export function unpinApp(userData, id) {
    var _a;
    // Use known hub tile ids if available, ex: ShellTeams instead of Teams
    id = getHubTileIdFromFirstPartyWorkloadId(id) || id;
    var unpinnedIndex = (_a = userData.pinnedApps.find(function (app) { return app.id === id; })) === null || _a === void 0 ? void 0 : _a.pinnedIndex;
    if (unpinnedIndex === undefined) {
        // Cannot find app with id
        return userData;
    }
    var pinnedApps = userData.pinnedApps
        .filter(function (app) { return app.pinnedIndex !== unpinnedIndex; })
        .sort(function (item1, item2) { return item1.pinnedIndex - item2.pinnedIndex; })
        .map(function (app, index) { return (__assign(__assign({}, app), { pinnedIndex: index })); }); // Renumber the indexes beginning with 0
    return __assign(__assign({}, userData), { pinnedApps: pinnedApps });
}
export function moveApp(userData, id, updatedIndex) {
    var _a;
    // Use known hub tile ids if available, ex: ShellTeams instead of Teams
    id = getHubTileIdFromFirstPartyWorkloadId(id) || id;
    var oldIndex = (_a = userData.pinnedApps.find(function (app) { return app.id === id; })) === null || _a === void 0 ? void 0 : _a.pinnedIndex;
    if (oldIndex === undefined) {
        // Cannot find app with id
        return userData;
    }
    var pinnedApps = userData.pinnedApps
        .map(function (app) {
        var pinnedIndex = app.pinnedIndex;
        if (app.id === id) {
            if (updatedIndex > oldIndex) {
                // Move the app in between the apps with pinnedIndexes of {updatedIndex} and {updatedIndex + 1}
                pinnedIndex = updatedIndex + 0.5;
            }
            else {
                // Move the app in between the apps with pinnedIndexes of {updatedIndex - 1} and {updatedIndex}
                pinnedIndex = updatedIndex - 0.5;
            }
        }
        return __assign(__assign({}, app), { pinnedIndex: pinnedIndex });
    })
        .sort(function (item1, item2) { return item1.pinnedIndex - item2.pinnedIndex; })
        .map(function (app, index) { return (__assign(__assign({}, app), { pinnedIndex: index })); }); // Renumber the indexes beginning with 0
    return __assign(__assign({}, userData), { pinnedApps: pinnedApps });
}
//# sourceMappingURL=utils.js.map